/**
 * Utility functions for athlete data display
 */

interface AthleteNameFields {
  first_name?: string | null;
  last_name?: string | null;
  name?: string;
}

/**
 * Constructs a full name from first_name and last_name, with fallback to name field.
 * Always returns "FirstName LastName" format when both are available.
 */
export function getAthleteFullName(athlete: AthleteNameFields): string {
  if (athlete.first_name && athlete.last_name) {
    return `${athlete.first_name} ${athlete.last_name}`.trim();
  }
  if (athlete.first_name) {
    return athlete.first_name;
  }
  if (athlete.last_name) {
    return athlete.last_name;
  }
  return athlete.name || 'Unknown';
}

/**
 * Gets initials from athlete name for avatar fallbacks
 */
export function getAthleteInitials(athlete: AthleteNameFields): string {
  const fullName = getAthleteFullName(athlete);
  return fullName
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

/**
 * Formats physical stats for display
 */
export function formatHeight(height: string | null | undefined): string | null {
  if (!height) return null;
  return height;
}

export function formatWeight(weight: string | null | undefined): string | null {
  if (!weight) return null;
  return weight;
}

export function formatAge(age: number | null | undefined): string | null {
  if (!age) return null;
  return `${age} yrs`;
}

export function formatBirthDate(birthDate: string | null | undefined): string | null {
  if (!birthDate) return null;
  try {
    return new Date(birthDate).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  } catch {
    return birthDate;
  }
}
